import React from 'react'

const eventTypes = [
  { name: "Eventi Aziendali", image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=600&h=800&auto=format&fit=crop" },
  { name: "Fiere & Stand", image: "https://images.unsplash.com/photo-1531973576160-7125cd663d86?q=80&w=600&h=800&auto=format&fit=crop" },
  { name: "Shooting & Set", image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=600&h=800&auto=format&fit=crop" }
]

const EventTypes = () => {
  return (
    <section id="events" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif font-bold text-brand-green mb-4">Per Ogni Occasione</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">Qualunque sia il tuo evento, abbiamo la soluzione verde perfetta per valorizzarlo.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {eventTypes.map((event, index) => (
            <div key={index} className="relative group overflow-hidden rounded-lg shadow-xl aspect-[3/4]">
              <img src={event.image} alt={event.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6">
                <h3 className="text-white text-3xl font-serif">{event.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default EventTypes